import React from 'react';

import { Permission } from '@admin/components/helpers/permission';
import { logisticsDetailedLoadURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { LOGISTICS } from '@admin/libraries/access_control_catalog.generated';

import { LogisticsLoadForm } from './form/form';

export const LogisticsNewLoad: React.FC = () => {
  useTitle('Create Load');
  const onSubmit = async (id: string) => {
    window.location.href = logisticsDetailedLoadURL({ id });
  };

  return (
    <Permission resource={LOGISTICS.resource} action={LOGISTICS.actions.update}>
      <LogisticsLoadForm load={undefined} editMode={false} onSave={onSubmit} />
    </Permission>
  );
};
